@import '~style-sheet-helpers/core.less';

.grid-and-footer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: calc(100% ~'-' 446px);

  &.no-sidebar {
    max-width: 100%;
  }
}

.grid {
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 15px;
}

.disclaimer {
  padding: 10px 0 10px 16px;
  font-size: 14px;
  line-height: 20px;
}
